import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';

export default function ActionsDropdown({ selectedCoal, user, onView, onReport, onPublish, onUnpublish,
    onHistory, onEdit, onDelete, hideView = false }) {
    const { t } = useTranslation();
    const [ dropdownOpen, setDropdownOpen ] = useState(false);
    const handleToggle = () => { setDropdownOpen(!dropdownOpen); }

    return (
        <Dropdown isOpen={dropdownOpen} toggle={handleToggle} className="navbar-item navbar-user dropdown me-3 align-self-end" tag="div">
            <DropdownToggle className="navbar-link dropdown-toggle d-flex align-items-center btn-auto-width">
                <span style={{ cursor:"pointer"}}>
                    <span> {t('carvão.result.ação')} </span>
                    <b className="caret text-white-100"/>
                </span>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu dropdown-menu-end" tag="div">
                {
                    !hideView &&
                    <>
                        <DropdownItem onClick={onView}>{t('carvão.result.botão.visualizar')}</DropdownItem> 
                        <div className="dropdown-divider"></div>
                    </>
                }

                {
                    (user && (user.is_admin == 1 || user.is_admin == 2)) &&
                    <>
                        <DropdownItem onClick={onReport}>{t('carvão.result.botão.relatorio')}</DropdownItem>
                        {selectedCoal.status === 1 &&
                            <DropdownItem onClick={onPublish}>{t('carvão.result.botão.publicar')}</DropdownItem>}
                        {selectedCoal.status === 2 &&
                            <DropdownItem onClick={onUnpublish}>{t('carvão.result.botão.privar')}</DropdownItem>}
                        <DropdownItem onClick={onHistory}>{t('carvão.result.botão.historico')}</DropdownItem>

                        <div className="dropdown-divider"></div>

                        <DropdownItem onClick={onEdit}>{t('carvão.result.botão.editar')}</DropdownItem>
                        <DropdownItem onClick={onDelete}>{t('carvão.result.botão.excluir')}</DropdownItem>
                    </>
                }
                {
                    (user && user.is_admin == 0 && user.name == selectedCoal.user.name) &&
                    <>
                        {selectedCoal.status === 1 &&
                            <DropdownItem onClick={onPublish}>{t('carvão.result.botão.publicar')}</DropdownItem>}
                        {selectedCoal.status === 2 &&
                            <DropdownItem onClick={onUnpublish}>{t('carvão.result.botão.privar')}</DropdownItem>}

                        <div className="dropdown-divider"></div>

                        <DropdownItem onClick={onEdit}>{t('carvão.result.botão.editar')}</DropdownItem>
                        <DropdownItem onClick={onDelete}>{t('carvão.result.botão.excluir')}</DropdownItem>
                    </>
                }
                {
                    (!user || (user && user.is_admin == 0 && !(user.name == selectedCoal.user.name))) &&
                        <DropdownItem disabled>{t('carvão.result.botão.relatorio')}</DropdownItem>
                }
            </DropdownMenu>
        </Dropdown>
    );
}